import Vue from "vue";
import moment from "moment";

Vue.filter('dateFormatter', function (value) {
    //var date = new Date(value);
    return moment(value).format("MM/DD/YYYY hh:mm A");
})

Vue.filter('shortName', function (value, maxChar) {
    if (value.length <= maxChar) {
        return value;
    } else {
        return value.substring(0, maxChar) + "...";
    }
})